import { ChevronsLeft, ChevronsRight, MoveLeft, MoveRight } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

import { usePdfViewerContext } from './pdf-viewer-provider'

export function PdfViewerBottomControls() {
  const {
    canGoNext,
    canGoPrevious,
    commitPageInput,
    goToFirstPage,
    goToLastPage,
    goToNextPage,
    goToPreviousPage,
    handlePageInputChange,
    pageInput,
    totalPages,
  } = usePdfViewerContext()

  return (
    <div className="pointer-events-none absolute bottom-1 left-1/2 z-30 w-[min(95%,560px)] -translate-x-1/2">
      <div className="pointer-events-auto flex items-center justify-center gap-3 rounded-xl border border-white/10 bg-black/85 px-3 py-2 text-white shadow-xl backdrop-blur">
        <Button
          aria-label="First page"
          disabled={!canGoPrevious}
          onClick={goToFirstPage}
          size="icon"
          variant="ghost"
          className="h-9 w-9 border border-white/15 bg-white/10 text-white hover:bg-white/20"
        >
          <ChevronsLeft className="size-4" />
        </Button>
        <Button
          aria-label="Previous page"
          disabled={!canGoPrevious}
          onClick={goToPreviousPage}
          size="icon"
          variant="ghost"
          className="h-9 w-9 border border-white/15 bg-white/10 text-white hover:bg-white/20"
        >
          <MoveLeft className="size-4" />
        </Button>

        <div className="flex items-center gap-2 text-sm">
          <span className="text-white/80">Page</span>
          <Input
            className="h-9 w-16 border-white/20 bg-white/10 text-center text-white placeholder:text-white/60"
            value={pageInput}
            onChange={event => handlePageInputChange(event.target.value)}
            onBlur={commitPageInput}
            onKeyDown={event => {
              if (event.key === 'Enter') {
                commitPageInput()
              }
            }}
            inputMode="numeric"
            aria-label="Go to page"
          />
          <span className="text-white/80">/ {totalPages || 0}</span>
        </div>

        <Button
          aria-label="Next page"
          disabled={!canGoNext}
          onClick={goToNextPage}
          size="icon"
          variant="ghost"
          className="h-9 w-9 border border-white/15 bg-white/10 text-white hover:bg-white/20"
        >
          <MoveRight className="size-4" />
        </Button>
        <Button
          aria-label="Last page"
          disabled={!canGoNext}
          onClick={goToLastPage}
          size="icon"
          variant="ghost"
          className="h-9 w-9 border border-white/15 bg-white/10 text-white hover:bg-white/20"
        >
          <ChevronsRight className="size-4" />
        </Button>
      </div>
    </div>
  )
}
